import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Italic = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M5.55669 17.2261C4.89653 17.2261 4.41524 16.6011 4.58391 15.9629V15.9629C4.70059 15.5213 5.1 15.2138 5.55669 15.2138H7.41659L10.245 4.75217H8.88021C8.23574 4.75217 7.76338 4.14572 7.92115 3.52086V3.52086C8.03206 3.08161 8.42718 2.77385 8.88021 2.77385H14.48C15.1245 2.77385 15.5969 3.3803 15.4391 4.00516V4.00516C15.3282 4.44441 14.9331 4.75217 14.48 4.75217H12.5119L9.68351 15.2138H11.1155C11.7756 15.2138 12.2569 15.8388 12.0883 16.477V16.477C11.9716 16.9185 11.5722 17.2261 11.1155 17.2261H5.55669Z"
        fill={color}
      />
    </svg>
  )
})

export default Italic
